import { Box, Paper } from '@mui/material';
import { VideoCarouselHeader } from '../components/VideoCarousel/VideoCarouselHeader';
import { VideoCarouselEmptyState } from '../components/VideoCarousel/VideoCarouselEmptyState';
import { VideoCarouselList } from '../components/VideoCarousel/VideoCarouselList';
import { VideoCarouselInfoBox } from '../components/VideoCarousel/VideoCarouselInfoBox';
import { useEffect } from 'react';
import { useVideoCarousels } from '../hooks/useVideoCarousels';
import { useFotbollPlaySubmit } from '../api/FotbollPlaySubmitProvider';

export function VideoCarouselTab() {
  const { carousels, openCreateCarousel, openEditCarousel, deleteCarousel } = useVideoCarousels();
  const { registerTabPayload } = useFotbollPlaySubmit();

  useEffect(() => {
    return registerTabPayload(2, () => ({ carousels }));
  }, [carousels, registerTabPayload]);

  return (
    <Paper variant="outlined" sx={{ mt: 3, mx: 3, p: 0 }}>
      <Box sx={{ p: 3 }}>
        <VideoCarouselHeader onCreateCarousel={openCreateCarousel} />

        {carousels.length === 0 ? (
          <VideoCarouselEmptyState />
        ) : (
          <VideoCarouselList
            carousels={carousels}
            onEditCarousel={openEditCarousel}
            onDeleteCarousel={deleteCarousel}
          />
        )}

        <VideoCarouselInfoBox />
      </Box>
    </Paper>
  );
}
